module.exports = __webpack_public_path__ + "img/add_poster.d5fefd4d.png";